import Request from './request';
import consts from "@/consts.js";

async function fetch(data) {
    return Request('get', "api/stocks/", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/stocks/" + id);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/stocks/edit?id=" + id, data);
    } else {
        return Request('post', "api/stocks/add" , data);
    }
}

async function fetchAllForSelect (data) {
  if (!data) data = {}
  data.limit = consts.limitAll //获取全部
  // data.fieldFilter = [
  //     "id",
  //     "code",
  //     "name",
  //     "stock_area",
  //     "stock_roadway_setting",
  //     "stock_district_code",
  //     "position_name_display"
  // ]; //仅筛选少许必要字段

  return Request('get', 'api/stocks/select', data, false, false, true)
}

export default {
    fetch,
    fetchOne,
    save,
    fetchAllForSelect,
};